export const FETCH_CATEGORY_INIT_ACTION = "FETCH_CATEGORY_INIT_ACTION";
export const FETCH_CATEGORY_SUCCESS_ACTION = FETCH_CATEGORY_INIT_ACTION + "_SUCCESS";
export const FETCH_CATEGORY_FAIL_ACTION = FETCH_CATEGORY_INIT_ACTION + "_ERROR";

export const FETCH_SUB_CATEGORY_INIT_ACTION = "FETCH_SUB_CATEGORY_INIT_ACTION";
export const FETCH_SUB_CATEGORY_SUCCESS_ACTION = FETCH_SUB_CATEGORY_INIT_ACTION + "_SUCCESS";
export const FETCH_SUB_CATEGORY_FAIL_ACTION = FETCH_SUB_CATEGORY_INIT_ACTION + "_ERROR";

export const ADD_RATECARD_INIT_ACTION = "ADD_RATECARD_INIT_ACTION";
export const ADD_RATECARD_SUCCESS_ACTION = ADD_RATECARD_INIT_ACTION + "_SUCCESS";
export const ADD_RATECARD_FAIL_ACTION = ADD_RATECARD_INIT_ACTION + "_ERROR";

export const FETCH_RATECARD_INIT_ACTION = "FETCH_RATECARD_INIT_ACTION";
export const FETCH_RATECARD_SUCCESS_ACTION = FETCH_RATECARD_INIT_ACTION + "_SUCCESS";
export const FETCH_RATECARD_FAIL_ACTION = FETCH_RATECARD_INIT_ACTION + "_ERROR";

export const EDIT_RATECARD_INIT_ACTION = "EDIT_RATECARD_INIT_ACTION";
export const EDIT_RATECARD_SUCCESS_ACTION = EDIT_RATECARD_INIT_ACTION + "_SUCCESS";
export const EDIT_RATECARD_FAIL_ACTION = EDIT_RATECARD_INIT_ACTION + "_ERROR";

export const DELETE_RATECARD_INIT_ACTION = "DELETE_RATECARD_INIT_ACTION";
export const DELETE_RATECARD_SUCCESS_ACTION = DELETE_RATECARD_INIT_ACTION + "_SUCCESS";
export const DELETE_RATECARD_FAIL_ACTION = DELETE_RATECARD_INIT_ACTION + "_ERROR";

export const FETCH_LOAD_METRIC_MAP_INIT_ACTION = "FETCH_LOAD_METRIC_MAP_INIT_ACTION";
export const FETCH_LOAD_METRIC_MAP_SUCCESS_ACTION = FETCH_LOAD_METRIC_MAP_INIT_ACTION + "_SUCCESS";
export const FETCH_LOAD_METRIC_MAP_FAIL_ACTION = FETCH_LOAD_METRIC_MAP_INIT_ACTION +"_ERROR";